var _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgLogoInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4324 23.5C11.4324 16.8352 16.8352 11.4324 23.5001 11.4324C30.1648 11.4324 35.5676 16.8352 35.5676 23.5C35.5676 30.1648 30.1648 35.5676 23.5001 35.5676C16.8352 35.5676 11.4324 30.1648 11.4324 23.5ZM23.5 31.3333C19.1737 31.3333 15.6667 27.8263 15.6667 23.5C15.6667 19.1737 19.1737 15.6667 23.5 15.6667C27.8262 15.6667 31.3333 19.1737 31.3333 23.5C31.3333 27.8263 27.8262 31.3333 23.5 31.3333Z",
    fill: "url(#paint0_linear_1142_881)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4324 23.5C11.4324 16.8352 16.8352 11.4324 23.5001 11.4324C30.1648 11.4324 35.5676 16.8352 35.5676 23.5C35.5676 30.1648 30.1648 35.5676 23.5001 35.5676C16.8352 35.5676 11.4324 30.1648 11.4324 23.5ZM23.5 31.3333C19.1737 31.3333 15.6667 27.8263 15.6667 23.5C15.6667 19.1737 19.1737 15.6667 23.5 15.6667C27.8262 15.6667 31.3333 19.1737 31.3333 23.5C31.3333 27.8263 27.8262 31.3333 23.5 31.3333Z",
    fill: "url(#paint1_radial_1142_881)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0443 13.7756C37.6018 13.7756 38.8644 12.5131 38.8644 10.9557C38.8644 9.39821 37.6018 8.13562 36.0443 8.13562C34.487 8.13562 33.2244 9.39821 33.2244 10.9557C33.2244 12.5131 34.487 13.7756 36.0443 13.7756Z",
    fill: "url(#paint2_linear_1142_881)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0443 13.7756C37.6018 13.7756 38.8644 12.5131 38.8644 10.9557C38.8644 9.39821 37.6018 8.13562 36.0443 8.13562C34.487 8.13562 33.2244 9.39821 33.2244 10.9557C33.2244 12.5131 34.487 13.7756 36.0443 13.7756Z",
    fill: "url(#paint3_radial_1142_881)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5 0C17.1178 0 16.3175 0.0270522 13.811 0.141418C11.3097 0.255503 9.60138 0.652797 8.10661 1.23377C6.56127 1.83423 5.25074 2.63777 3.94421 3.94421C2.63777 5.25074 1.83423 6.56127 1.23377 8.10661C0.652797 9.60138 0.255503 11.3097 0.141418 13.811C0.0270522 16.3175 0 17.1178 0 23.5C0 29.8822 0.0270522 30.6825 0.141418 33.189C0.255503 35.6903 0.652797 37.3986 1.23377 38.8934C1.83423 40.4387 2.63777 41.7493 3.94421 43.0558C5.25074 44.3622 6.56127 45.1658 8.10661 45.7663C9.60138 46.3472 11.3097 46.7445 13.811 46.8586C16.3175 46.9729 17.1178 47 23.5 47C29.8822 47 30.6825 46.9729 33.189 46.8586C35.6903 46.7445 37.3986 46.3472 38.8934 45.7663C40.4387 45.1658 41.7493 44.3622 43.0558 43.0558C44.3622 41.7493 45.1658 40.4387 45.7663 38.8934C46.3472 37.3986 46.7445 35.6903 46.8586 33.189C46.9729 30.6825 47 29.8822 47 23.5C47 17.1178 46.9729 16.3175 46.8586 13.811C46.7445 11.3097 46.3472 9.60138 45.7663 8.10661C45.1658 6.56127 44.3622 5.25074 43.0558 3.94421C41.7493 2.63777 40.4387 1.83423 38.8934 1.23377C37.3986 0.652797 35.6903 0.255503 33.189 0.141418C30.6825 0.0270522 29.8822 0 23.5 0ZM23.5001 4.23423C29.7748 4.23423 30.518 4.2582 32.996 4.37126C35.2872 4.47574 36.5316 4.85857 37.3596 5.1804C38.4566 5.60671 39.2394 6.11594 40.0617 6.93833C40.8841 7.76062 41.3933 8.54345 41.8196 9.64037C42.1414 10.4684 42.5243 11.7128 42.6287 14.004C42.7418 16.482 42.7658 17.2252 42.7658 23.5C42.7658 29.7748 42.7418 30.518 42.6287 32.996C42.5243 35.2872 42.1414 36.5316 41.8196 37.3596C41.3933 38.4565 40.8841 39.2394 40.0617 40.0617C39.2394 40.8841 38.4566 41.3933 37.3596 41.8196C36.5316 42.1414 35.2872 42.5243 32.996 42.6287C30.5184 42.7418 29.7752 42.7658 23.5001 42.7658C17.2248 42.7658 16.4817 42.7418 14.004 42.6287C11.7128 42.5243 10.4685 42.1414 9.64038 41.8196C8.54346 41.3933 7.76062 40.8841 6.93833 40.0617C6.11604 39.2394 5.60671 38.4565 5.18041 37.3596C4.85858 36.5316 4.47574 35.2872 4.37127 32.996C4.25821 30.518 4.23423 29.7748 4.23423 23.5C4.23423 17.2252 4.25821 16.482 4.37127 14.004C4.47574 11.7128 4.85858 10.4684 5.18041 9.64037C5.60671 8.54345 6.11594 7.76062 6.93833 6.93833C7.76062 6.11594 8.54346 5.60671 9.64038 5.1804C10.4685 4.85857 11.7128 4.47574 14.004 4.37126C16.482 4.2582 17.2253 4.23423 23.5001 4.23423Z",
    fill: "url(#paint4_linear_1142_881)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5 0C17.1178 0 16.3175 0.0270522 13.811 0.141418C11.3097 0.255503 9.60138 0.652797 8.10661 1.23377C6.56127 1.83423 5.25074 2.63777 3.94421 3.94421C2.63777 5.25074 1.83423 6.56127 1.23377 8.10661C0.652797 9.60138 0.255503 11.3097 0.141418 13.811C0.0270522 16.3175 0 17.1178 0 23.5C0 29.8822 0.0270522 30.6825 0.141418 33.189C0.255503 35.6903 0.652797 37.3986 1.23377 38.8934C1.83423 40.4387 2.63777 41.7493 3.94421 43.0558C5.25074 44.3622 6.56127 45.1658 8.10661 45.7663C9.60138 46.3472 11.3097 46.7445 13.811 46.8586C16.3175 46.9729 17.1178 47 23.5 47C29.8822 47 30.6825 46.9729 33.189 46.8586C35.6903 46.7445 37.3986 46.3472 38.8934 45.7663C40.4387 45.1658 41.7493 44.3622 43.0558 43.0558C44.3622 41.7493 45.1658 40.4387 45.7663 38.8934C46.3472 37.3986 46.7445 35.6903 46.8586 33.189C46.9729 30.6825 47 29.8822 47 23.5C47 17.1178 46.9729 16.3175 46.8586 13.811C46.7445 11.3097 46.3472 9.60138 45.7663 8.10661C45.1658 6.56127 44.3622 5.25074 43.0558 3.94421C41.7493 2.63777 40.4387 1.83423 38.8934 1.23377C37.3986 0.652797 35.6903 0.255503 33.189 0.141418C30.6825 0.0270522 29.8822 0 23.5 0ZM23.5001 4.23423C29.7748 4.23423 30.518 4.2582 32.996 4.37126C35.2872 4.47574 36.5316 4.85857 37.3596 5.1804C38.4566 5.60671 39.2394 6.11594 40.0617 6.93833C40.8841 7.76062 41.3933 8.54345 41.8196 9.64037C42.1414 10.4684 42.5243 11.7128 42.6287 14.004C42.7418 16.482 42.7658 17.2252 42.7658 23.5C42.7658 29.7748 42.7418 30.518 42.6287 32.996C42.5243 35.2872 42.1414 36.5316 41.8196 37.3596C41.3933 38.4565 40.8841 39.2394 40.0617 40.0617C39.2394 40.8841 38.4566 41.3933 37.3596 41.8196C36.5316 42.1414 35.2872 42.5243 32.996 42.6287C30.5184 42.7418 29.7752 42.7658 23.5001 42.7658C17.2248 42.7658 16.4817 42.7418 14.004 42.6287C11.7128 42.5243 10.4685 42.1414 9.64038 41.8196C8.54346 41.3933 7.76062 40.8841 6.93833 40.0617C6.11604 39.2394 5.60671 38.4565 5.18041 37.3596C4.85858 36.5316 4.47574 35.2872 4.37127 32.996C4.25821 30.518 4.23423 29.7748 4.23423 23.5C4.23423 17.2252 4.25821 16.482 4.37127 14.004C4.47574 11.7128 4.85858 10.4684 5.18041 9.64037C5.60671 8.54345 6.11594 7.76062 6.93833 6.93833C7.76062 6.11594 8.54346 5.60671 9.64038 5.1804C10.4685 4.85857 11.7128 4.47574 14.004 4.37126C16.482 4.2582 17.2253 4.23423 23.5001 4.23423Z",
    fill: "url(#paint5_radial_1142_881)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1142_881",
    x1: 2.7423,
    y1: 2.47093,
    x2: 17.561,
    y2: 59.7914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E60D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.142763,
    stopColor: "#913BAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.761458,
    stopColor: "#D52D88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F26D4F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1142_881",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.2289 47) rotate(32.1601) scale(43.8955 31.5902)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED276"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17024,
    stopColor: "#FDBD61",
    stopOpacity: 0.975006
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.454081,
    stopColor: "#F6804D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E83D5C",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1142_881",
    x1: 2.7423,
    y1: 2.47093,
    x2: 17.561,
    y2: 59.7914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E60D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.142763,
    stopColor: "#913BAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.761458,
    stopColor: "#D52D88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F26D4F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1142_881",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.2289 47) rotate(32.1601) scale(43.8955 31.5902)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED276"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17024,
    stopColor: "#FDBD61",
    stopOpacity: 0.975006
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.454081,
    stopColor: "#F6804D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E83D5C",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1142_881",
    x1: 2.7423,
    y1: 2.47093,
    x2: 17.561,
    y2: 59.7914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E60D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.142763,
    stopColor: "#913BAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.761458,
    stopColor: "#D52D88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F26D4F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_1142_881",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.2289 47) rotate(32.1601) scale(43.8955 31.5902)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED276"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17024,
    stopColor: "#FDBD61",
    stopOpacity: 0.975006
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.454081,
    stopColor: "#F6804D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E83D5C",
    stopOpacity: 0.01
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoInstagram);
export default __webpack_public_path__ + "static/media/logo_instagram.cfa3df16d7234927cd6bfa0966369769.svg";
export { ForwardRef as ReactComponent };